import { Tag } from 'antd';
import classNames from 'classnames';
import { useTags } from '../model';
import { ViolationsDrawer } from '../../ViolationsDrawer';
import styles from './styles.module.scss';

export const StatusTag = () => {
  const {
    state: { tags, violationsOpen, violationsType },
    methods: { handleOpenViolations, handleCloseViolations },
  } = useTags();

  if (!tags) {
    return null;
  }

  return (
    <>
      <div className={styles.wrapper}>
        {tags.map((tag) => (
          <Tag
            key={tag.styleKey}
            icon={tag.icon}
            color={tag.color}
            className={classNames(styles.tag, styles[`tag_${tag.styleKey}`])}
            onClick={() => handleOpenViolations(tag.type)}
          >
            {tag.text}
          </Tag>
        ))}
      </div>
      <ViolationsDrawer
        open={violationsOpen}
        onClose={handleCloseViolations}
        type={violationsType}
      />
    </>
  );
};
